export default __webpack_public_path__ + "static/media/Icon-Layers-White.0b7dbc41.png";